import { List } from "immutable";
import { RootState } from "common/reducers";
import { createSelector } from "reselect";
import { currentMeasurement } from "common/selectors/measurement.common.selectors";
import { recordChanged } from "common/helpers/Record";

export const rootKey = "doors";

export const door = (state: RootState, props: any) => state.getIn([rootKey, "byId", props.doorId]);
export const lastSavedDoor = (state: RootState, props: any) => state.getIn([rootKey, "lastSavedById", props.doorId]);

/**
 * Gets the doors for the given ids
 *
 * @param {RootState} state The RootState
 * @param {{}} props The props
 * @returns {List<DoorRecord>} doors
 */
export const doors = (state: RootState, props: any) => {
  return props.doorIds.map((id: number) => door(state, { doorId: id }));
};
/**
 * Gets the last saved doors for the given ids
 *
 * @param {RootState} state The RootState
 * @param {{}} props The props
 * @returns {List<DoorRecord>} lastSavedDoors
 */
export const lastSavedDoors = (state: RootState, props: any) => {
  return props.doorIds.map((id: number) => lastSavedDoor(state, { doorId: id }));
};

/**
 * Gets the doors for the current measurement
 *
 * @param {RootState} state The RootState
 * @param {{}} options NONE
 * @returns {List<DoorRecord>} doors
 */
export const currentMeasurementDoors = createSelector(
  [currentMeasurement, (state: RootState) => state],
  (measurement, state) => {
    return doors(state, { doorIds: measurement?.get("door_ids") || List() });
  },
);

/**
 * Gets the last saved doors for the current measurement
 *
 * @param {RootState} state The RootState
 * @param {{}} options NONE
 * @returns {List<DoorRecord>} lastSavedDoors
 */
export const currentMeasurementLastSavedDoors = createSelector(
  [currentMeasurement, (state: RootState) => state],
  (measurement, state) => {
    return lastSavedDoors(state, { doorIds: measurement?.get("door_ids") || List() });
  },
);

/**
 * Checks if the doors have changed on the current measurement
 *
 * @param {RootState} state RootState
 * @param {{}} options NONE
 * @returns {boolean} True if the doors have changed, false otherwise
 */
export const doorsChanged = (state: RootState): boolean => {
  return recordChanged(currentMeasurementDoors(state), currentMeasurementLastSavedDoors(state));
};
